import { useSyncExternalStore } from 'react';

const listen = callback => { window.addEventListener('resize', callback); return () => window.removeEventListener('resize', callback); };
const device = () => window.innerWidth < 768 ? 'mobile' : window.innerWidth < 1024 ? 'tablet' : 'desktop';
export const useImageDevice = () => useSyncExternalStore(listen, device, () => 'desktop');
export const imageDisplay = (owner = {}, field = 'image', screen = 'desktop', fallbackFit = 'contain', fallbackPosition = 'center') => {
  const config = owner.imagePresentation?.[field] || {};
  const values = { ...config.desktop, ...(screen === 'desktop' ? {} : config[screen]) };
  const inheritedFit = field === 'image' ? owner.imageFit : field === 'backgroundImage' ? owner.backgroundSize : null;
  const fit = values.fit || inheritedFit || 'contain';
  const position = values.position || owner[`${field}FocalPoint`] || (field === 'backgroundImage' ? owner.backgroundPosition : '') || fallbackPosition;
  return { fit: fit === 'contain' ? 'contain' : 'cover', position };
};
export const backgroundDisplayStyle = (owner, field, screen, fallbackFit = 'cover', fallbackPosition = 'center') => {
  const { fit, position } = imageDisplay(owner, field, screen, fallbackFit, fallbackPosition);
  return { backgroundSize: fit, backgroundPosition: position, backgroundRepeat: 'no-repeat' };
};